import React from 'react'
import classNames from 'classnames'
import css from './flex-row.module.css'

function FlexRow ({ className, style, children }) {
  return <div className={classNames(css.flexRow, className)} style={style}>{children}</div>
}

export default FlexRow
